<ul role="menu" [id]="listId" appList [class.show]="open" (active)="onRouteActive($event)" appRouterLinkActiveTrigger>
    <li class="section-header" aria-hidden="true">
        {{ 'v3-header-menu-item-admin-settings' | translate }}
    </li>
    @for (item of items$ | async; track item.name) {
        <li role="none">
            <a class="menu-item" (click)="close()" [routerLink]="item.route" routerLinkActive appListItem role="menuitem">
                <app-icon [name]="item.icon" class="tw-size-5" />
                <span class="menu-item-text">{{ item.name | translate }}</span>
            </a>
        </li>
    }
</ul>
